<template>
  <div v-if="answers" class="answer-wrap">
    <!-- 题库标题 -->

    <div class="answer-title">
      <h5>【{{ answers.title }}】</h5>
    </div>
    <div ref="answerContent" class="answer-subject">
      <!-- 题目标题 -->
      <div class="subject-title">
        <h3>{{ answers.questions[current - 1].type | type }}</h3>
        <h5 class="question-title">
          {{ current }}、{{ answers.questions[current - 1].title }}
        </h5>

        <!-- 图片类标题 -->
        <div class="flex">
          <div
            v-if="answers.questions[current - 1].pic"
            class="subject-title-icon flex"
          >
            <img :src="answers.questions[current - 1].pic" alt />
          </div>
          <!-- 视频 -->
          <video
            v-if="answers.questions[current - 1].video.PlayURL"
            ref="video"
            :src="answers.questions[current - 1].video.PlayURL"
            :poster="answers.questions[current - 1].video.cover"
            webkit-playsinline="true"
            class="video"
            x5-playsinline="true"
            playsinline
            controlsList="nodownload"
            preload="auto"
            controls
          >
            不支持 video 标签
          </video>
        </div>

        <subject-options-old
          ref="sub"
          :disable-form="!doAgain"
          :disable-reset="!doAgain"
          :was-correct="
            !doAgain ? answers.questions[current - 1].is_correct === 1 : null
          "
          :answered="!doAgain ? answers.questions[current - 1].item_id : null"
          :analysis="!doAgain ? 'always' : 'normal'"
          :analysis-str="answers.questions[current - 1].analysis"
          :options="answers.questions[current - 1].items"
          :type="answers.questions[current - 1].type"
          btn-up
          btn-down
          @up="up"
          @down="down"
        ></subject-options-old>
      </div>
    </div>

    <div class="status-bar container">
      <div class="mu-bottom-nav" tabindex="0">
        <div class="mu-bottom-nav-shift-wrapper">
          <!-- 计时器 -->
          <div
            v-if="$route.query.type === 'wrong'"
            class="mu-bottom-item"
            tabindex="0"
            @click="doAgain = !doAgain"
          >
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none;"
              >
                compare_arrows
              </i>
              <span class="mu-bottom-item-text">
                {{ doAgain ? '错题模式' : '练习模式' }}
              </span>
            </div>
          </div>
          <!-- 返回目录 -->
          <div
            class="mu-bottom-item"
            tabindex="0"
            style="color: rgb(255, 255, 255);"
            @click="goBack"
          >
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none;"
              >
                undo
              </i>
              <span class="mu-bottom-item-text">返回</span>
            </div>
          </div>
          <!-- 答题序号 -->
          <div
            class="mu-bottom-item"
            tabindex="0"
            @click="openFullscreenDialog"
          >
            <div class="mu-bottom-item-wrapper">
              <div class="mu-ripple-wrapper"></div>
              <i
                class="mu-icon material-icons mu-bottom-item-icon"
                style="user-select: none;"
              >
                format_list_bulleted
              </i>
              <span class="mu-bottom-item-text">
                共{{ answers.questions.length }}题
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择题目序号弹窗 -->
    <mu-dialog
      :open.sync="openFullscreen"
      class="select-order"
      width="360"
      transition="slide-right"
      fullscreen
    >
      <mu-appbar title="选择答题序号" color="primary">
        <mu-button slot="right" flat @click="closeFullscreenDialog">
          <mu-icon value="close"></mu-icon>
        </mu-button>
      </mu-appbar>
      <mu-row
        v-for="(group, key) in answerCardObj"
        :key="key"
        class="order-box"
      >
        <div class="question-list-type">{{ `——${key}——` }}</div>
        <!-- 弹窗内容 -->
        <mu-col
          v-for="(item, index) in group"
          :key="index"
          class="order"
          span="2"
          @click="selectOrder(item.Q_index + 1)"
        >
          <div
            :class="{
              active: current === item.Q_index + 1,
              error: item.is_correct === 0,
              correct: item.is_correct === 1,
            }"
          >
            {{ item.Q_index + 1 }}
          </div>
        </mu-col>
      </mu-row>
    </mu-dialog>
  </div>
</template>

<script>
import {
  fetchMockTestRecordsHistoryDetails,
  fetchMistakeCollectionDetails,
} from '@/api/index'
import SubjectOptionsOld from '@/components/SubjectOptionsOld'

export default {
  components: { SubjectOptionsOld },
  // 过滤器
  filters: {
    // 题目类型
    type(value) {
      switch (value) {
        case 5:
          return '判断题'
        case 1:
          return '单选题'
        case 2:
          return '多选题'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      // 是否要继续
      isContinue: false,
      //章节id
      // 答题页类型
      pageType: 'practice',
      // 当前题数
      current: 0,
      // 答题信息 current
      answers: null,
      openFullscreen: false,

      doAgain: false,

      answerCardObj: {},
    }
  },
  // 计算属性
  computed: {},
  // 侦听属性
  watch: {
    current(val) {
      if (this.$route.query.type === 'test') {
        this.analysis = this.answers.questions[val - 1].is_correct === 1
      }
      this.$backTop(this.$refs.answerContent)

      console.log(`第${val}道题， 回答T/F: ${this.analysis}`)
    },
  },
  beforeRouteEnter(to, from, next) {
    let result
    const a_id = to.query.answer_id
    const isTest = to.query.type === 'test'
    if (isTest) {
      result = fetchMockTestRecordsHistoryDetails({
        answer_id: a_id,
      })
    } else {
      result = fetchMistakeCollectionDetails({
        answer_id: a_id,
      })
    }

    result.then((res) => {
      let practise = res.questions
      for (let index = 0; index < practise.length; index++) {
        // 如果为多选
        if (practise[index].item_id !== null) {
          if (practise[index].type === 2) {
            // 字符串转数组
            practise[index].item_id = practise[index].item_id.split(',')
          }
        }
      }
      next((vm) => vm.setQuestionLists(res))
    })
  },
  // 生命周期 - 创建完毕状态
  created() {},
  // 生命周期 - 挂载前状态
  beforeMount() {},
  // 方法
  methods: {
    // 获取记录题库
    setQuestionLists(result) {
      this.answers = result
      this.current = 1

      switch (this.$route.query.type) {
        case 'test':
          this.$setHtmlTitle('考试记录')
          break
        case 'wrong':
          this.$setHtmlTitle('错题集')
          break
        default:
          break
      }
    },

    // 返回章节
    goBack() {
      this.$router.go(-1)
    },

    // 打开选择序号窗口
    openFullscreenDialog() {
      this.openFullscreen = true

      // 根据题型分割
      const answerCardObj = {}
      let type = null
      this.answers.questions.map((item, index) => {
        type = this.getQuestionTypeName(item.type)
        item.Q_index = index
        if (answerCardObj[type]) {
          answerCardObj[type].push(item)
        } else {
          answerCardObj[type] = [item]
        }
      })
      this.answerCardObj = answerCardObj
    },
    getQuestionTypeName(type) {
      let res
      switch (type) {
        case 1:
          res = '单选题'
          break
        case 2:
          res = '多选题'
          break
        case 5:
          res = '判断题'
          break
      }
      return res
    },
    // 关闭选择序号窗口
    closeFullscreenDialog() {
      this.openFullscreen = false
    },
    selectOrder(order) {
      this.current = order
      // 关闭选择序号窗口
      this.closeFullscreenDialog()
    },
    // 上一题
    up() {
      if (this.current !== 1) {
        this.current--
      } else {
        // 提示这是第一题
        this.$NewToast.message('已经是第一道题啦')
      }
    },
    // 下一题
    down() {
      const isLast = this.current === this.answers.questions.length
      if (isLast) {
        this.$confirm('已经是最后一道题了，要返回吗？', '提示').then(
          ({ result }) => {
            if (result) {
              this.goBack()
            }
          }
        )
        return
      }
      this.current++
    },
  },
}
</script>

<style lang="scss" scoped>
// 按钮组
.answer-btn {
  position: fixed;
  bottom: 66px;
  left: 0;
  transform: translate(50%, 0%);
  text-align: center;
  button {
    font-weight: 800;
    color: #fff;
    background-color: #214ecf;
  }
}
.video {
  width: 100%;
  margin-top: 10px;
}
.flex {
  display: flex;
  flex-flow: column;
}
</style>
